export const useStopScroll = () => {
    const scrollPosition = window.scrollY || window.pageYOffset;
    document.body.style.overflow = "hidden";
    window.scrollTo(0, scrollPosition);
};

export const useAllowScroll = () => {
    document.body.style.overflow = "auto";
};
